(() => {
  const activeClass = 'is-lionz-page-transitioning';
  const transitionDelay = 180;
  const transitionElement = document.querySelector('.lionz-page-transition');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let navigationPending = false;

  if (!transitionElement) return;

  const isPrimaryActivation = (event) => {
    if (event.defaultPrevented || event.button !== 0) return false;
    return !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  };

  const resolveUrl = (href) => {
    try {
      return new URL(href, window.location.href);
    } catch {
      return null;
    }
  };

  const isEligibleUrl = (url) => {
    if (!url || !['http:', 'https:'].includes(url.protocol)) return false;
    if (url.origin !== window.location.origin) return false;

    const isSameDocumentHash =
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      Boolean(url.hash);

    return !isSameDocumentHash;
  };

  const navigate = (url) => {
    if (navigationPending) return;

    navigationPending = true;
    document.body.classList.add(activeClass);

    window.setTimeout(
      () => window.location.assign(url.href),
      reducedMotion.matches ? 0 : transitionDelay,
    );
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!isPrimaryActivation(event)) return;
      if (!(event.target instanceof Element)) return;

      const swatch = event.target.closest('.product-card-swatch[data-href]');
      if (!swatch) return;

      const url = resolveUrl(swatch.dataset.href);
      if (!isEligibleUrl(url)) return;

      event.preventDefault();
      event.stopPropagation();
      navigate(url);
    },
    true,
  );

  document.addEventListener('click', (event) => {
    if (!isPrimaryActivation(event)) return;
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[href]');
    if (!link) return;
    if (link.matches('.js-no-transition, [data-no-transition]')) return;
    if (link.hasAttribute('download')) return;
    if (link.target && link.target.toLowerCase() !== '_self') return;

    const url = resolveUrl(link.href);
    if (!isEligibleUrl(url)) return;

    event.preventDefault();
    navigate(url);
  });

  window.addEventListener('pageshow', () => {
    navigationPending = false;
    document.body.classList.remove(activeClass);
  });
})();
